import { render } from "./Widget3.vue?vue&type=template&id=6f2ee58c"
import script from "./Widget3.vue?vue&type=script&lang=ts"
export * from "./Widget3.vue?vue&type=script&lang=ts"
script.render = render

export default script